import { createSlice } from '@reduxjs/toolkit';

export const AIGenerationModalSlice = createSlice({
    name: 'AIGenerationModal',
    initialState: {
        show: false,
        dynamicAIPrompt: '',
        AIContent: {
            key: '',
            value: '',
        }
    },
    reducers: {
        toggleAIGenerationModal: (state, action) => {
            state.show = !state.show;
            if (action.payload && action.payload.dynamicAIPrompt) {
                state.dynamicAIPrompt = action.payload.dynamicAIPrompt;
            } else {
                state.dynamicAIPrompt = '';
            }
        },
        setAIContent: (state, action) => {
            if (action.payload && action.payload.key && action.payload.value) {
                state.AIContent = {
                    key: action.payload.key,
                    value: action.payload.value,
                };
            } else {
                state.AIContent = {
                    key: '',
                    value: '',
                };
            }
        }
    },
});

export const { toggleAIGenerationModal, setAIContent } = AIGenerationModalSlice.actions;
export default AIGenerationModalSlice.reducer;
